import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, deleteEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'campaigntrack/orderItem/FETCH_REQUEST'
const FETCH_SUCCESS = 'campaigntrack/orderItem/FETCH_SUCCESS'
const FETCH_FAILURE = 'campaigntrack/orderItem/FETCH_FAILURE'

const CREATE_REQUEST = 'campaigntrack/orderItem/CREATE_REQUEST'
const CREATE_SUCCESS = 'campaigntrack/orderItem/CREATE_SUCCESS'
const CREATE_FAILURE = 'campaigntrack/orderItem/CREATE_FAILURE'

const UPDATE_REQUEST = 'campaigntrack/orderItem/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'campaigntrack/orderItem/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'campaigntrack/orderItem/UPDATE_FAILURE'

const DELETE_REQUEST = 'campaigntrack/orderItem/DELETE_REQUEST'
const DELETE_SUCCESS = 'campaigntrack/orderItem/DELETE_SUCCESS'
const DELETE_FAILURE = 'campaigntrack/orderItem/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadOrderItems(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/order_items', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ORDER_ITEM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function createOrderItem(orderItem, options){
  const config = {
    method: 'POST',
    data: JSON.stringify({
      order_item: orderItem,
    }),
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/order-items', options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ORDER_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateOrderItem(orderItem, options){
  const config = {
    method: 'PUT',
    data: JSON.stringify({
      order_item: orderItem,
    }),
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/order-items/${orderItem.id}`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ORDER_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function linkArtworkToOrderItem(orderItemId, artworkId, options){
  const config = {
    method: 'PUT',
  }

  return (dispatch) => {
    dispatch(updateRequest())
    const promise = api(`/order-items/${orderItemId}/link-realbase-artwork/${artworkId}`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ORDER_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export function unlinkArtworkFromOrderItem(orderItemId, artworkId, options){
  const config = {
    method: 'PUT',
  }

  return (dispatch) => {
    dispatch(updateRequest())
    const promise = api(`/order-items/${orderItemId}/unlink-realbase-artwork/${artworkId}`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ORDER_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export function deleteOrderItem(orderItem){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/order-items/${orderItem.id}`, {}, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.ORDER_ITEM)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export function artworkBuilderConfig(orderItem, options){
  return () => {
    const promise = api(`/order-items/${orderItem.id}/artwork-builder-config`, options)
      .then(({ data }) => ({ success: true, data }))
      .catch((data) => {
        const errors = handleError(data)
        return { success: false, errors }
      })

    return promise
  }
}

export function loadShortcodeData(orderItem, options){
  return () => {
    const promise = api(`/order-items/${orderItem.id}/shortcode-data`, options)
      .then(({ data }) => ({ success: true, data }))
      .catch((data) => {
        const errors = handleError(data)
        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors: action.errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
